import { client } from "../../Client/Client";
import { manageInvoiceServices } from "../../Configs/BackendRoutes";
import {   backendUrl as URL } from "../../Configs/Constant";
import { APIResponseInterface } from "../../Interface/ManageClient";
import { AcceptOrRejectInvoicePayloadInterface, ManageInvoiceGridPayloadInterface } from "../../Interface/ManageInvoice";


export const fetchManageInvoicesGridDataService = async (payload: ManageInvoiceGridPayloadInterface ) => {
    // PS_09, PS_20, PS_33, PS_44, PS_55

      const config = {
        method: 'POST',
        url: URL + manageInvoiceServices.retrieveInvoiceDetails,
        headers: {
            'Content-Type': 'application/json'
        },
        data: payload
    };
    const response : APIResponseInterface= await client(config);

    return response;
};



export const postAcceptOrRejectInvoiceServices = async (payload: AcceptOrRejectInvoicePayloadInterface ) => {
    // PS_09, PS_20, PS_33, PS_44, PS_55

      const config = {
        method: 'POST',
        url: URL + manageInvoiceServices.acceptRejectInvoice,
        headers: {
            'Content-Type': 'application/json'
        },
        data: payload
    };
    const response : APIResponseInterface= await client(config);

    return response;
};


export const fetchInvoiceService = async (invoiceUUID: string)=>{
    const config = {
        method: 'GET',
        url: URL + manageInvoiceServices.fetchInvoice + "?invoiceUUID=" +invoiceUUID,
        headers: {
            'Content-Type': 'application/json'
        }
    };    
    const response = await client(config);
    return response;
}


export const fetchFormDynamicData = async ()=>{
    const config = {
        method: 'GET',
        url: URL + manageInvoiceServices.invoiceFormDynamicData,
        headers: {
            'Content-Type': 'application/json'
        }
    };    
    const response = await client(config);
    return response;
}